import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bi bi-chevron-double-left",
  style: {"margin-right":"10px"}
}
const _hoisted_2 = {
  key: 1,
  class: "bi bi-chevron-double-right",
  style: {"margin-left":"10px"}
}

import { hapticsImpactLight } from 'util/device-util';
import { useModule } from 'src/modules/modules';


export default /*#__PURE__*/_defineComponent({
  __name: 'nav-button',
  props: {
    type: null,
    audioKey: null,
    useBannerOffset: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
    type: 'back' | 'next',
    audioKey?: string,
    useBannerOffset?: boolean
}

const { audio } = useModule();



const handleClick = () => {
    hapticsImpactLight();
    audio.play(props.audioKey ?? 'FX_menu_btn');
    emit('click');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _mergeProps(_ctx.$attrs, {
    class: "au-nav-btn",
    onClick: handleClick
  }), [
    (__props.type === 'back')
      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (__props.type === 'next')
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : _createCommentVNode("", true)
  ], 16))
}
}

})